import { useState, useEffect } from 'react';
import { adminApi } from '../../../utils/api';
import { Spinner, InsightCard } from '../shared';

export default function UserInsightsTab({ userId }) {
    const [insights, setInsights] = useState([]);
    const [loading, setLoading] = useState(true);
    const [days, setDays] = useState(30);

    useEffect(() => {
        loadInsights();
    }, [userId, days]);

    const loadInsights = async () => {
        setLoading(true);
        try {
            const result = await adminApi.getUserInsights(userId, { days });
            setInsights(result.insights || []);
        } catch (err) {
            console.error('Failed to load insights:', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Spinner text="Loading insights..." center />;
    }

    return (
        <div className="h-full overflow-y-auto">
            <div className="mb-4">
                <select
                    value={days}
                    onChange={(e) => setDays(Number(e.target.value))}
                    className="h-9 rounded-md border border-gray-200 px-3 text-sm focus:outline-none focus:ring-1 focus:ring-gray-400"
                >
                    <option value={7}>Last 7 days</option>
                    <option value={30}>Last 30 days</option>
                    <option value={90}>Last 90 days</option>
                </select>
            </div>

            <div className="space-y-4">
                {insights.length > 0 ? (
                    insights.map((insight, idx) => (
                        <InsightCard
                            key={idx}
                            severity={insight.severity}
                            title={insight.title}
                            description={insight.description}
                        />
                    ))
                ) : (
                    <div className="rounded-lg border-2 border-green-200 bg-green-50 p-6 text-center">
                        <svg className="w-12 h-12 text-green-600 mx-auto mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <h3 className="text-base font-semibold text-gray-900 mb-1">All Good!</h3>
                        <p className="text-sm text-gray-600">No insights or alerts for this period</p>
                        <p className="text-xs text-gray-500 mt-2">All metrics are within normal range</p>
                    </div>
                )}
            </div>
        </div>
    );
}
